WishlistButton = window.WishlistButton ?= {}

DealEventPipe = require '../../deal/frontend/event_pipe'

WishlistButton = ->
  $wishlistButton = wishlistPayload = dealId = csrfToken = selectedOptionUUID = null
  $wishlistButtonTextAdd = $wishlistButtonTextRemove = null
  init = ({carousel, csrf, wishlist}, done) ->
    $wishlistButton = $("#add-to-wishlist-btn")
    $wishlistButtonTextAdd = $("#add-to-wishlist-btn-text-add")
    $wishlistButtonTextRemove = $("#add-to-wishlist-btn-text-remove")
    wishlistPayload = wishlist
    dealId = carousel?.dealId
    selectedOptionUUID = wishlistPayload.selectedOptionUUID if wishlistPayload.selectedOptionUUID
    csrfToken = csrf
    listenToOptionSelection()
    $ ->
      $wishlistButton.on "click", wishlistButtonClicked
      done()

  updateWishlistedNotifier = (optionUUID) ->
    $wishlistButton.removeClass "wishlisted"
    $wishlistButtonTextAdd.removeClass "hidden"
    $wishlistButtonTextRemove.addClass "hidden"
    optionUUIDFilter = (item) -> item.optionId is optionUUID
    if optionUUID && _.filter(wishlistPayload.items, optionUUIDFilter).length > 0
      $wishlistButton.addClass "wishlisted"
      $wishlistButtonTextAdd.addClass "hidden"
      $wishlistButtonTextRemove.removeClass "hidden"

  updateRemoveItemUrl = (optionUUID) ->
    optionUUIDFilter = (item) -> item.optionId is optionUUID
    if optionUUID
      wishlistPayload.removeItemUrl = _.filter(wishlistPayload.items, optionUUIDFilter)?[0]?.removeItemUrl

  listenToOptionSelection = ->
    DealEventPipe.on "priceUpdate", (priceData) ->
      $tooltip = $('#select-option-tooltip')
      GIG.Tooltip.close $tooltip
      selectedOptionUUID = priceData.variationsSelected && priceData.uuid
      updateWishlistedNotifier selectedOptionUUID
      updateRemoveItemUrl selectedOptionUUID

  toggleWishlistButtonStyle = ->
    $wishlistButton.toggleClass "wishlisted"
    $wishlistButtonTextAdd.toggleClass "hidden"
    $wishlistButtonTextRemove.toggleClass "hidden"

  onAddItemSuccess = (data) ->

    updateWishlistItems = (newItem) ->
      addedItem =
        dealId: dealId,
        itemId: newItem.itemId,
        listId: newItem.listId,
        removeItemUrl: "/deals/wishlists_proxy/remove/#{newItem.listId}/#{newItem.itemId}"
      addedItem.optionId = selectedOptionUUID if selectedOptionUUID
      wishlistPayload.items.push addedItem

    wishlistPayload.removeItemUrl = "/deals/wishlists_proxy/remove/#{data.listId}/#{data.itemId}"
    toggleWishlistButtonStyle()
    updateWishlistItems data

  _checkMultiOptionSelection = ->
    wishlistPayload.isMultiOptionsAvailable && !selectedOptionUUID

  addItemToWishlist = ->
    $wishlistButton.prop 'disabled', true
    $.ajax
      url: wishlistPayload.addItemUrl #"/deals/wishlists_proxy/addbyname?listName=default"
      dataType: "json"
      type: "POST"
      data:
        dealId: dealId
        optionId: selectedOptionUUID if selectedOptionUUID
        _csrf: csrfToken
      error: (jqxhr, textStatus, error) ->
        $("#wishlist-add-error").fadeIn().delay(3000).fadeOut()
      success: (data, status, xhr) ->
        onAddItemSuccess data
      complete: ->
        $wishlistButton.prop 'disabled', false

  removeItemFromWishlist = ->
    $wishlistButton.prop 'disabled', true
    $.ajax
      url: wishlistPayload.removeItemUrl #"/deals/wishlists_proxy/remove/763bc9b9-0a4e-4e1a-af6d-f63652f99b91/9b2c3e2c-1442-4779-a89e-ae3ed5eddc62"
      dataType: "json"
      type: "POST"
      data:
        _csrf: csrfToken
      error: (jqxhr, textStatus, error) ->
        $("#wishlist-remove-error").fadeIn().delay(3000).fadeOut()
      success: (data, textStatus, error) ->
        toggleWishlistButtonStyle()
        wishlistPayload.items = _.filter( wishlistPayload.items, (i) -> i.optionId != selectedOptionUUID ) # remove item from the items array
      complete: ->
        $wishlistButton.prop 'disabled', false

  wishlistButtonClicked = (e) ->
    e.preventDefault()
    if _checkMultiOptionSelection()
      return $wishlistButton.trigger "show-tooltip"
    if $wishlistButton.hasClass "wishlisted"
      removeItemFromWishlist()
    else
      addItemToWishlist()

  init: init
  onAddItemSuccess: onAddItemSuccess

window.WishlistButton = WishlistButton()

module.exports = WishlistButton
